import { useCodesStore } from './useCodesStore';

export { useCodesStore };

const codeStore = {
  useCodesStore,
};

export default codeStore;
